import { useRef } from 'react';
import Sidebar from '../Sidebar/index';
import Topbar from '../Topbar/index';

const Layout = ({ children }) => {
  const scrollContainerRef = useRef(null);

  return (
    <div className="flex h-full w-full items-stretch">
      <Sidebar scrollContainerRef={scrollContainerRef} />
      <div
        className="relative flex h-full w-full flex-col overflow-auto"
        ref={scrollContainerRef}
      >
        <Topbar />
        <main className="min-h-0 min-w-0 flex-1 px-8 py-4">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
